module.exports = __webpack_public_path__ + "static/media/star-prata.7e0a5988.jpg";